const CLOUDINARY_HOST = 'https://fiverr-res.cloudinary.com';
const CLOUDINARY_IMAGE_OPTIMIZATION = 'f_auto,q_auto';
const FIVERR_URL = 'https://www.fiverr.com';

module.exports = {
    FIVERR_URL,
    CLOUDINARY_HOST,
    CLOUDINARY_IMAGE_OPTIMIZATION,
};
